import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BikeLibraryService } from '../../../../../services/bike-library.service';

@Component({
  selector: 'app-single-manufacturer-bike',
  templateUrl: './single-manufacturer-bike.component.html',
  styleUrls: ['./single-manufacturer-bike.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SingleManufacturerBikeComponent implements OnInit {
  public sku: string = '';
  public saleIdentifier: string = '';
  public partnerWidgetURL = '';
  public bike: any = null;
  public showNewBikeSaleBanner = false;
  public partner: any = {};

  constructor(
    private bikeLibraryService: BikeLibraryService,
    private route: ActivatedRoute,
    private router: Router,
    public sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.sku = params.get('sku');
      this.showNewBikeSaleBanner =
        params.get('showNewBikeSaleBanner') === 'true';
      this.getBike();
    });
    this.route.queryParams.subscribe((queryParams) => {
      this.saleIdentifier =
        queryParams['SaleIdentifier'] ||
        queryParams['Saleidentifier'] ||
        queryParams['saleIdentifier'] ||
        queryParams['saleidentifier'];
      if (
        this.saleIdentifier !== null &&
        this.saleIdentifier !== undefined &&
        this.saleIdentifier !== ''
      ) {
        this.getBikeSalePartnerDetails();
        this.reportEvent('BIKE_SALE_PAGE_VIEWED');
      }
    });
  }

  getBike() {
    this.bikeLibraryService.getManufacturerBike(this.sku).subscribe((bike) => {
      this.bike = bike;
      this.bike.images =
        bike.media === null
          ? []
          : bike.media.filter((x) => {
              return x.mediaType === 'Image';
            });
      this.bike.videos =
        bike.media === null
          ? []
          : bike.media.filter((x) => {
              return x.mediaType === 'Video';
            });
    });
  }

  getVideoURL(v: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(v.mediaURL);
  }

  getBikeSalePartnerDetails() {
    this.bikeLibraryService
      .getBikeSalePartnerDetails(this.saleIdentifier)
      .subscribe((partner) => {
        this.partner = partner;
        if (partner.offersBookingService && partner.externalKey) {
          this.partnerWidgetURL =
            'https://hubtigerbookings.z6.web.core.windows.net/bikes/?shop=' +
            partner.externalKey;
        }
      });
  }

  showSundaysInsuranceAU() {
    if (
      this.partner &&
      this.partner.partnerID &&
      this.partner.country.toUpperCase() === 'AU'
    ) {
      return true;
    } else {
      return false;
    }
  }

  getSundaysLink() {
    if (
      this.partner &&
      this.partner.partnerID &&
      this.partner.country.toUpperCase() === 'AU'
    ) {
      return `https://sundaysinsurance.com.au/quick-quote/?step=1&promo=HUBTIGER&bike_value=${this.partner.unitPrice_IncludingTax || 0}&bike_make=${this.bike.manufacturer}&year_model=${this.bike.year}&customer_name=${this.partner.firstName}&customer_surname=${this.partner.surname}&bike_model=${this.bike.bikeModel}`;
    } else {
      return '';
    }
  }

  openLink(link, event) {
    this.reportEvent(event);
    window.open(link, '_blank');
  }

  reportEvent(event) {
    this.bikeLibraryService
      .postBikeSaleReportEvent(this.saleIdentifier, event)
      .subscribe((res) => {});
  }

  nextImage(url) {
    console.log(url);
    var index = this.bike.images
      .map((x) => {
        return x.mediaURL;
      })
      .indexOf(url);
    console.log(index);
    if (index === -1) {
      index = 0;
    }
    console.log(index);
    this.bike.primaryImageURL =
      this.bike.images[
        index + 1 >= this.bike.images.length ? 0 : index + 1
      ].mediaURL;
  }

  prevImage(url) {
    var index = this.bike.images
      .map((x) => {
        return x.mediaURL;
      })
      .indexOf(url);
    if (index === -1) {
      index = 0;
    }
    this.bike.primaryImageURL =
      this.bike.images[
        index - 1 < 0 ? this.bike.images.length - 1 : index - 1
      ].mediaURL;
  }
}
